module.exports = __webpack_public_path__ + "static/media/wood.73beb237.svg";